<section  class="latest_static_card">
<div class="row">
    <div class="col-lg-4 col-md-3 col-sm-12" *ngFor="let course of rows"> 
      <div class="card">
          <div class="card-content">
              <div class="card-image">
                  <img class="card-img-top img-fluid" src="assets/course-img.png" alt="Card image cap">
                  <div class="card_content_title position_to_be_absolute">
                      <h6>{{course?.title}}</h6>
                  </div>
              </div>
                  <div class="card-body">
                      <div class="price_full_radius">
                        <a>{{ course?.maxfees ?? 0 | currency:'INR' }}</a>
                        <a *ngIf="course?.maxfees=='undefined'">{{0 | currency:'INR'}}</a>
                      </div>
                      <div class="card_content_main">
                          <p>{{course?.course_category[0]?.displayname}}</p>
                      </div>
                      <!-- <div class="card_content_title">
                          <h6>Title</h6>
                      </div> -->
                      <!-- <div class="card_content_rating">
                          <div class="rating_stars">
                              <i class="ft-star-on"></i>
                              <i class="ft-star-on"></i>
                              <i class="ft-star-on"></i>
                              <i class="ft-star-on"></i>
                              <i class="ft-star-on"></i>
                          </div>
                          <div class="rating_count">
                              <span>(0/5 Ratings)</span>
                          </div>
                      </div> -->
                      <!-- <div class="card_course_name">
                        <p>{{course?.about}}</p>
                      </div> -->
                      <div class="card_course_meta">
                        <ul class="modes">   
                            <li *ngFor="let mode of course?.course_mode"><span class="mx-1">
                                <i class="ft-airplay" *ngIf="mode?.displayname =='Classroom'"></i>
                                <i class="ft-user" *ngIf="mode?.displayname =='Online'"></i>
                                <i class="ft-list" *ngIf="mode?.displayname =='Self-Paced'"></i>
                                 {{mode?.displayname}}</span></li>
                        <!-- <li class="mr-15px"><i class="ft-list"></i> English</li>
                          <li> <i class="ft-user"></i> <span>Online</span></li> -->
                        </ul>
                      </div>
                      <div class="custom_button_card">
                        <button class="btn btn-primary" (click)="confirmUpdate(course._id,course.password)">Learn</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>